module.exports = __webpack_public_path__ + "img/usecargoazul.c1deddca.png";